import Box from "@mui/material/Box";
import styled from "styled-components";

export const StyledCommunitiesList = styled(Box)`
  //   margin-bottom: 0.5rem;
`;
